const chatModes = {
  CHAT: 'chat',
  CALL: 'call',
  VIDEO: 'video',
  AUDIO: 'audio'
}

export default chatModes